module.exports = __webpack_public_path__ + "static/media/external_env_4_media_12.b74307e6.webp";